import { SupportButton, SupportButtonHandle, SupportFormData } from '@skezi/ui';
import { MessageButtons } from '@skezi/ui/src/components/buttons/support/types';
import { t } from 'i18next';
import { forwardRef } from 'react';
import { useAuth } from '../../auth/useAuth';
import UsersService from '../../services/users.service';

export const WrappedSupportButton = forwardRef<SupportButtonHandle>(function WrappedSupportButtonComposant(props, ref) {
  const { user } = useAuth();
  const usersService = new UsersService();

  const onSubmit = async (data: SupportFormData) => {
    await usersService.sendSupportMessage(data.nickname, data.email, data.description);
  };

  const isProd = !import.meta.env.DEV && !import.meta.env.VITE_ACCOUNT_APP_HOST.includes('.dev');

  const messageBtns: Omit<MessageButtons, 'CONTACT_SUPPORT_BTN'> = {
    FAQ_BTN: {
      label: t('button.viewFAQ'),
      onClick: () => {
        window.open('/faq', '_blank', 'noopener');
      },
    },
  };

  return (
    <SupportButton
      messageButtons={messageBtns}
      variant={isProd ? 'form' : 'chatbot'}
      answerer='SKEZI'
      platform='SKEZI'
      errorLabel={t('error.basic')}
      onSubmit={onSubmit}
      successLabel={t('contact.success')}
      ref={ref}
      user={user ? { email: user?.email ?? '', nickname: '' } : undefined}
    />
  );
});
